import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import classNames from 'classnames';
import React, { useContext } from 'react';
import { isRtl } from '../../utils';
import { CLS_PREFIX } from '../../constants';
import OnDarkContext from '../OnDarkContext';
import { safeInvoke } from '../utils';
import Icon from '../Icon';

/**
 * FIXME: With the following code all @ts-ignore comments can be removed, but react-docgen cannot parse it.
 * const Link = <P extends any>({ ... }: LinkProps<P>) => {
 */

/**
 * `Link` is used for navigation purposes.
 * @since 1.9.0
 */
var Link = function Link(_ref) {
  var _classNames;

  var _ref$baseClassName = _ref.baseClassName,
      baseClassName = _ref$baseClassName === void 0 ? "".concat(CLS_PREFIX, "link") : _ref$baseClassName,
      className = _ref.className,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$pseudo = _ref.pseudo,
      pseudo = _ref$pseudo === void 0 ? false : _ref$pseudo,
      component = _ref.component,
      children = _ref.children,
      onKeyDown = _ref.onKeyDown,
      other = _objectWithoutProperties(_ref, ["baseClassName", "className", "onClick", "disabled", "pseudo", "component", "children", "onKeyDown"]);

  var Component = component ? component : 'a';
  var onDark = useContext(OnDarkContext);

  var props = _objectSpread({}, other, {
    onClick: onClick,
    className: classNames(baseClassName, className, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--disabled"), disabled), _defineProperty(_classNames, "".concat(baseClassName, "--pseudo"), pseudo), _defineProperty(_classNames, "".concat(baseClassName, "--on-dark"), onDark), _classNames))
  });

  var target = other.target;
  var external = !pseudo && target === '_blank';

  if (external && !props.rel) {
    props.rel = 'noopener noreferrer';
  }

  if (disabled) {
    props.onClick = function (e) {
      return e.preventDefault();
    };

    props.tabIndex = -1;
  } // accessibility


  if (onClick) {
    props.tabIndex = props.tabIndex || 0;

    props.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        e.currentTarget.click();
      }

      safeInvoke(onKeyDown, e);
    };
  }

  return (// @ts-ignore
    React.createElement(Component, props, children, external && React.createElement(Icon, {
      flipHorizontal: isRtl(),
      name: "arrow-diagonal-out",
      className: "".concat(baseClassName, "__external-icon")
    }))
  );
};

export default Link;